// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#widget-container .acknowledgement-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
}
#widget-container .modal {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 382px;
  background: white;
  padding: 28px 30px 28px 28px;
  border-radius: 5px;
  /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3); */
  text-align: center;
  z-index: 20;
  gap: 1.75rem;
  display: flex;
  flex-direction: column;
}
#widget-container .content-wrapper {
  display: flex;
  flex-direction: column;
}
#widget-container .acknowledgement-content {
  color: #000;
  font-family: "McKinseySans-Regular", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#widget-container .acknowledgement-content p {
  color: #000;
  font-family: "McKinseySans-Light", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 0.5rem;
}
#widget-container .acknowledgement-content a {
  color: #2251ff;
  text-decoration-line: none;
}
#widget-container .greeting {
  color: #000;
  font-family: Bower, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  padding: 20px 0px 16px 0px;
}
#widget-container .ack-button {
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
}
#widget-container .buttons-wrapper {
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["#widget-container .acknowledgement-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 15;\n}\n#widget-container .modal {\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80%;\n  max-width: 382px;\n  background: white;\n  padding: 28px 30px 28px 28px;\n  border-radius: 5px;\n  /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3); */\n  text-align: center;\n  z-index: 20;\n  gap: 1.75rem;\n  display: flex;\n  flex-direction: column;\n}\n#widget-container .content-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n#widget-container .acknowledgement-content {\n  color: #000;\n  font-family: \"McKinseySans-Regular\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n#widget-container .acknowledgement-content p {\n  color: #000;\n  font-family: \"McKinseySans-Light\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin-bottom: 0.5rem;\n}\n#widget-container .acknowledgement-content a {\n  color: #2251ff;\n  text-decoration-line: none;\n}\n#widget-container .greeting {\n  color: #000;\n  font-family: Bower, sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  display: flex;\n  padding: 20px 0px 16px 0px;\n}\n#widget-container .ack-button {\n  padding: 12px 24px;\n  font-size: 16px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n#widget-container .buttons-wrapper {\n  gap: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
